/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v3";
import { remap as remap$ } from "../../lib/primitives.js";

export type ListHistoricalAlarmActivationsRequest = {
  /**
   * Cursor to start from
   */
  cursor?: string | undefined;
  /**
   * Number of results to return per page
   */
  size?: number | undefined;
  agentId: string;
};

/** @internal */
export type ListHistoricalAlarmActivationsRequest$Outbound = {
  cursor?: string | undefined;
  size: number;
  agent_id: string;
};

/** @internal */
export const ListHistoricalAlarmActivationsRequest$outboundSchema: z.ZodType<
  ListHistoricalAlarmActivationsRequest$Outbound,
  z.ZodTypeDef,
  ListHistoricalAlarmActivationsRequest
> = z.object({
  cursor: z.string().optional(),
  size: z.number().int().default(30),
  agentId: z.string(),
}).transform((v) => {
  return remap$(v, {
    agentId: "agent_id",
  });
});

export function listHistoricalAlarmActivationsRequestToJSON(
  listHistoricalAlarmActivationsRequest: ListHistoricalAlarmActivationsRequest,
): string {
  return JSON.stringify(
    ListHistoricalAlarmActivationsRequest$outboundSchema.parse(
      listHistoricalAlarmActivationsRequest,
    ),
  );
}
